<aside
  class="fixed flex flex-col top-0 px-5 left-0 bg-white dark:bg-gray-900 dark:border-gray-800 text-gray-900 h-screen transition-all duration-300 ease-in-out z-[100001] border-r border-gray-200"
  [ngClass]="{
    'w-[290px]': (isExpanded$ | async) || (isMobileOpen$ | async),
    'w-[90px]': !((isExpanded$ | async) || (isMobileOpen$ | async)),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true,
  }"
>
  <div
    class="py-8 flex"
    [ngClass]="{
      'xl:justify-center': !(isExpanded$ | async),
      'justify-start': (isExpanded$ | async) || (isMobileOpen$ | async),
    }"
  >
    <button
      type="button"
      class="rounded-lg transition-opacity hover:opacity-85 focus:outline-none"
      (click)="handleLogoToggle()"
      aria-label="Toggle sidebar"
    >
      @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
        <img class="dark:hidden w-[85px] h-[85px]" src="/assets/logo.png" alt="Logo" />
        <img
          class="hidden dark:block w-[85px] h-[85px]"
          src="/assets/logo.png"
          alt="Logo"
          width="150"
          height="40"
        />
      } @else {
        <img class="w-[32px] h-[32px]" src="/assets/logo.png" alt="Logo" />
      }
    </button>
  </div>

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear no-scrollbar">
    <nav class="mb-6">
      <div class="flex flex-col gap-4">
        <!-- Menu Section -->
        <div>
          <ul class="flex flex-col gap-1">
            @for (nav of visibleNavItems(); track $index; let i = $index) {
              <li>
                @if (nav.subItems) {
                  <button
                    (click)="toggleSubmenu('main', i)"
                    (mouseenter)="showCollapsedTooltip($event, nav.name)"
                    (mouseleave)="hideCollapsedTooltip()"
                    (focus)="showCollapsedTooltip($event, nav.name)"
                    (blur)="hideCollapsedTooltip()"
                    [disabled]="!isEnabled(nav)"
                    [attr.aria-label]="nav.name"
                    [attr.aria-disabled]="!isEnabled(nav)"
                    class="menu-item group cursor-pointer"
                    [class.menu-item-active]="
                      isEnabled(nav) &&
                      openSubmenu === 'main-' + i &&
                      !isCollapsedSubmenu(nav, 'main-' + i)
                    "
                    [class.menu-item-inactive]="isEnabled(nav) && openSubmenu !== 'main-' + i"
                    [class.menu-item-disabled]="!isEnabled(nav)"
                    [ngClass]="{
                      'xl:justify-center': !(isExpanded$ | async),
                      'xl:justify-start': (isExpanded$ | async) || (isMobileOpen$ | async),
                      'xl:!gap-0 xl:!px-0 xl:py-1.5 xl:hover:bg-transparent dark:xl:hover:bg-transparent':
                        isCollapsedSubmenu(nav, 'main-' + i),
                      'xl:hover:!bg-transparent dark:xl:hover:!bg-transparent':
                        isCollapsedSubmenuNav(nav),
                    }"
                  >
                    <span
                      class="menu-item-icon-size"
                      [class.menu-item-icon-active]="isEnabled(nav) && openSubmenu === 'main-' + i"
                      [class.menu-item-icon-inactive]="
                        isEnabled(nav) && openSubmenu !== 'main-' + i
                      "
                      [ngClass]="{
                        'group-hover:!text-brand-500 dark:group-hover:!text-brand-400':
                          isCollapsedSubmenuNav(nav),
                      }"
                      [innerHTML]="nav.icon | trustedStaticHtml"
                    >
                    </span>
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <span class="menu-item-text">
                        {{ nav.name }}
                      </span>
                    }
                    @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                      <svg
                        [ngClass]="{
                          'rotate-180 text-brand-500':
                            isEnabled(nav) && openSubmenu === 'main-' + i,
                        }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="ml-auto w-5 h-5 transition-transform duration-200"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    } @else if (canShowCollapsedSubmenu(nav)) {
                      <svg
                        [ngClass]="{
                          'rotate-180 !text-slate-900 dark:!text-white':
                            isEnabled(nav) && openSubmenu === 'main-' + i,
                        }"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="absolute left-1/2 top-1/2 h-3.5 w-3.5 shrink-0 translate-x-[10px] -translate-y-1/2 text-slate-700 transition-colors duration-200 group-hover:!text-brand-500 dark:text-slate-200 dark:group-hover:!text-brand-400"
                        aria-hidden="true"
                      >
                        <path
                          d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                          stroke="currentColor"
                          stroke-width="2.1"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                    }
                  </button>
                  <div
                    class="overflow-hidden transition-all duration-300"
                    [id]="'main-' + i"
                    [style.display]="
                      (isExpanded$ | async) || (isMobileOpen$ | async) ? 'block' : 'none'
                    "
                    [ngStyle]="{
                      height:
                        openSubmenu === 'main-' + i
                          ? (subMenuHeights['main-' + i] || 0) + 'px'
                          : '0px',
                    }"
                  >
                    <ul class="mt-2 space-y-1 ml-9">
                      @for (subItem of nav.subItems; track $index) {
                        <li>
                          <a
                            [routerLink]="isEnabled(subItem) ? subItem.path : null"
                            routerLinkActive=""
                            (click)="
                              isEnabled(subItem)
                                ? closeSidebarAfterNavigation()
                                : $event.preventDefault()
                            "
                            [attr.aria-disabled]="!isEnabled(subItem)"
                            class="menu-dropdown-item"
                            [ngClass]="{
                              'menu-dropdown-item-inactive':
                                isEnabled(subItem) && !isSubItemActive(nav, subItem),
                              'menu-dropdown-item-active':
                                isEnabled(subItem) && isSubItemActive(nav, subItem),
                              'menu-item-disabled': !isEnabled(subItem),
                            }"
                          >
                            {{ subItem.name }}
                          </a>
                        </li>
                      }
                    </ul>
                  </div>
                  @if (isCollapsedSubmenu(nav, 'main-' + i)) {
                    <ul class="mt-1 flex w-full flex-col items-center">
                      @for (subItem of nav.subItems; track $index) {
                        <li class="w-full">
                          <a
                            [routerLink]="isEnabled(subItem) ? subItem.path : null"
                            (click)="
                              isEnabled(subItem)
                                ? closeSidebarAfterNavigation()
                                : $event.preventDefault()
                            "
                            [attr.aria-disabled]="!isEnabled(subItem)"
                            class="mx-auto flex h-7 max-w-[72px] items-center justify-center overflow-hidden text-ellipsis whitespace-nowrap rounded-md px-2 text-center text-xs font-medium transition-colors"
                            [attr.aria-label]="subItem.name"
                            [ngClass]="{
                              'bg-brand-50 text-brand-600 dark:bg-brand-500/15 dark:text-brand-300':
                                isEnabled(subItem) && isSubItemActive(nav, subItem),
                              'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200':
                                isEnabled(subItem) && !isSubItemActive(nav, subItem),
                              'menu-item-disabled': !isEnabled(subItem),
                            }"
                          >
                            {{ subItem.compactName || subItem.name }}
                          </a>
                        </li>
                      }
                    </ul>
                  }
                } @else {
                  @if (nav.path) {
                    <a
                      [routerLink]="isEnabled(nav) ? nav.path : null"
                      routerLinkActive="menu-item-active"
                      [class.menu-item-active]="isEnabled(nav) && isNavActive(nav)"
                      (mouseenter)="showCollapsedTooltip($event, nav.name)"
                      (mouseleave)="hideCollapsedTooltip()"
                      (focus)="showCollapsedTooltip($event, nav.name)"
                      (blur)="hideCollapsedTooltip()"
                      (click)="
                        isEnabled(nav) ? closeSidebarAfterNavigation() : $event.preventDefault()
                      "
                      [attr.aria-label]="nav.name"
                      [attr.aria-disabled]="!isEnabled(nav)"
                      class="menu-item group"
                      [ngClass]="{
                        'menu-item-inactive': isEnabled(nav) && !isNavActive(nav),
                        'menu-item-disabled': !isEnabled(nav),
                      }"
                    >
                      <span
                        class="menu-item-icon-size"
                        [ngClass]="{
                          'menu-item-icon-active': isEnabled(nav) && isNavActive(nav),
                          'menu-item-icon-inactive': isEnabled(nav) && !isNavActive(nav),
                        }"
                        [innerHTML]="nav.icon | trustedStaticHtml"
                      >
                      </span>
                      <span class="menu-item-text">
                        @if ((isExpanded$ | async) || (isMobileOpen$ | async)) {
                          {{ nav.name }}
                        }
                      </span>
                    </a>
                  }
                }
              </li>
            }
          </ul>
        </div>
        <!-- end main menu -->
      </div>
    </nav>
  </div>
</aside>

@if (collapsedTooltip) {
  <div
    class="pointer-events-none fixed z-[100002] -translate-y-1/2 whitespace-nowrap rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 shadow-lg shadow-slate-900/10 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100"
    [style.left.px]="collapsedTooltip.left"
    [style.top.px]="collapsedTooltip.top"
    role="tooltip"
  >
    <span
      class="absolute -left-1 top-1/2 h-2 w-2 -translate-y-1/2 rotate-45 border-b border-l border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800"
    ></span>
    <span class="relative">{{ collapsedTooltip.label }}</span>
  </div>
}
